import React, { Component } from 'react';
// prop types
import PropTypes from 'prop-types';
// create/edit react modal
import ReactModal from 'react-modal';
// react redux connect
import { connect } from 'react-redux';
// lodash is empty
import { isEmpty } from 'lodash';
// styled components
import styled from 'styled-components';
// material ui icons
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
// uuid v4
import uuid from 'uuid';

// material ui core imports
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress,
  Button,
  IconButton,
  Grid,
  withStyles,
} from '@material-ui/core';

// homemade components
import {
  RegularCard,
  ItemGrid,
  CustomInput,
} from "../../components";

// reducer action imports
import {
  loadLocations,
  createNewLocation,
  editLocation,
  deleteLocation,
  archiveLocationOffer
} from './reducer/actions';

// modal styled divs
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 20px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
`
const ModalContent = styled.div`
  position: relative;
  padding: 0px 20px;
  overflow: hidden;
  padding-bottom: 20px;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`
// custom modal styles
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)'
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: '572px'
  }
};

// define custom table cells
const CustomTableCell = withStyles(theme => ({
  head: {
    textAlign: 'center'
  },

  body: {
    fontSize: 16,
    textAlign: 'center'
  },
}))(TableCell);

// classes styles
const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

// 785 is the area code for Topeka, Kansas!
// Code Kansas!

// component declaration
class LocationsList extends Component {

  // constructor
  constructor (props) {
    super(props);
    // set up state
    this.state = {
      isEditing: false,
      id: '',
      modal: null,
      name: '',
      aboutLocation: '',
      hours: '',
      phone: '',
      email: '',
      site: '',
      location: '',
    };
    // binds
    this._onEditLocation = this._onEditLocation.bind(this);
    this._onCreateNewLocation = this._onCreateNewLocation.bind(this);
    this._onDeleteLocation = this._onDeleteLocation.bind(this);
  }

  // load in all locations
  componentDidMount () {
    this.props.loadLocations();
  }

  // on successful edit/create, close modal
  _onSuccess () {
    this.setState({ modal: null });
  }

  // on edit/create error, log
  _onError (error) {
    this.setState({ modal: null });
    console.log(error);
  }

  // delete a location
  _onDeleteLocation (id) {
    this.props.deleteLocation(id, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // begin editing a location
  initEditLocation (id) {
    const { locations } = this.props;
    const curLocation = locations.filter(location => (location.id === id))[0];

    const coords = curLocation.coords || {};

    this.setState({
      name: curLocation.name,
      aboutLocation: curLocation.about,
      hours: curLocation.hours,
      phone: curLocation.phone,
      email: curLocation.email,
      site: curLocation.site,
      location: curLocation.location,
      coordsLat: coords.lat,
      coordsLng: coords.lng,
      isEditing: true,
      id: id,
      modal: 'edit'
    });
  }

  // finish editing location
  _onEditLocation (id) {
    this.props.editLocation(id, {
      name: this.state.name,
      about: this.state.aboutLocation,
      hours: this.state.hours,
      phone: this.state.phone,
      email: this.state.email,
      site: this.state.site,
      location: this.state.location,
      coords: this.state.coordsLng && this.state.coordsLat ? ({
        lat: this.state.coordsLat,
        lng: this.state.coordsLng,
      }) : null,
      id: id
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // create a new location from state
  _onCreateNewLocation () {
    this.props.createNewLocation({
      name: this.state.name,
      about: this.state.aboutLocation,
      hours: this.state.hours,
      phone: this.state.phone,
      email: this.state.email,
      site: this.state.site,
      location: this.state.location,
      coords: this.state.coordsLng && this.state.coordsLat ? ({
        lat: this.state.coordsLat,
        lng: this.state.coordsLng,
      }) : null,
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // save location offer
  saveOffer() {
    const {
      offerEditingLocationId,
      offerId,
      offerName,
      offerTitle,
      offerSubTitle
    } = this.state;

    console.log('saveOffer', offerId, offerId || uuid.v4());

    const data = {
      offerId: offerId || uuid.v4(),
      offerName,
      offerTitle,
      offerSubTitle
    }

    this.props.editLocation(offerEditingLocationId, data,
      this._onSuccess.bind(this), this._onError.bind(this)
    );
  }

  // deactivate offer on a location
  turnOffOffer() {
    const {
      offerEditingLocationId,
    } = this.state;

    const data = {
      offerId: null,
      offerName: null,
      offerTitle: null,
      offerSubTitle: null,
    }

    this.setState(data);

    this.props.editLocation(offerEditingLocationId, data,
      this._onSuccess.bind(this), this._onError.bind(this)
    );
  }

  // show the Edit Location modal
  showEditModal () {
    this.setState({
      name: '',
      aboutLocation: '',
      hours: '',
      phone: '',
      email: '',
      site: '',
      location: '',
      modal: 'edit'
    })
  }

  // close modal
  _onCloseModal () {
    this.setState({ modal: null });
  }

  // edit existing offers (deprecated, apparently)
  editOffers(id) {

  }

  // archive existing offer
  archiveOffer() {
    const {
      offerEditingLocationId,
      offerId,
      offerName,
      offerTitle,
      offerSubTitle
    } = this.state;

    const data = {
      offerId,
      offerName,
      offerTitle,
      offerSubTitle
    }

    this.props.archiveLocationOffer(offerEditingLocationId, data,
      () => this.setState({
        offersArchive: {
          ...(this.state.offersArchive || {}),
          [offerId]: data
        },
        offerId: null,
        offerName: '',
        offerTitle: '',
        offerSubTitle: '',
      })
    );
  }

  // show the Edit Location modal
  renderEditModal() {
    return (
      <ReactModal isOpen={this.state.modal === 'edit'}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.isEditing ? 'Edit Location' : 'New Location'}
        ariaHideApp={false}
        style={customModalStyles}
      >
        {/* New or Edit Location modal */}
        <ModalHeader>
          {this.state.isEditing ? 'Edit Location' : 'New Location'}
        </ModalHeader>
        {/* Modal main body */}
        <ModalContent>
          <Grid container>
            {/* Location Name input */}
            <ItemGrid xs={12} sm={12} md={6}>
              <CustomInput
                labelText='Name'
                id='name'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.name,
                  onChange: (e)=>this.setState({ name: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Location Phone Number input TODO: add Phone Formatter */}
            <ItemGrid xs={12} sm={12} md={6}>
              <CustomInput
                labelText='Phone'
                id='phone'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.phone,
                  onChange: (e)=>this.setState({ phone: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Location Email input */}
            <ItemGrid xs={12} sm={12} md={6}>
              <CustomInput
                labelText='Email'
                id='email'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.email,
                  onChange: (e)=>this.setState({ email: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Location Website input */}
            <ItemGrid xs={12} sm={12} md={6}>
              <CustomInput
                labelText='Site'
                id='site'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.site,
                  onChange: (e)=>this.setState({ site: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Location Address input */}
            <ItemGrid xs={12} sm={12} md={12}>
              <CustomInput
                labelText='Full Address'
                id='location'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.location,
                  onChange: (e)=>this.setState({ location: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Location Latitude input */}
            <ItemGrid xs={12} sm={12} md={6}>
              <CustomInput
                labelText='Latitude'
                id='lat'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.coordsLat,
                  onChange: (e)=>this.setState({ coordsLat: e.target.value })
                }}
                />
            </ItemGrid>
            <ItemGrid xs={12} sm={12} md={6}>
              <CustomInput
                labelText='Longitude'
                id='lng'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.coordsLng,
                  onChange: (e)=>this.setState({ coordsLng: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Location Longitude input */}
            <ItemGrid xs={12} sm={12} md={12}>
              <CustomInput
                labelText='About Location'
                id='about'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.aboutLocation,
                  multiline: true,
                  rows: 2,
                  onChange: (e)=>this.setState({ aboutLocation: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Location Hours input TODO: figure out a better way to do this */}
            <ItemGrid xs={12} sm={12} md={12}>
              <CustomInput
                labelText='Hours'
                id='hours'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.hours,
                  multiline: true,
                  rows: 7,
                  onChange: (e)=>this.setState({ hours: e.target.value })
                }}
              />
            </ItemGrid>
          </Grid>
        </ModalContent>
        {/* Footer with Edit/Create and Cancel buttons */}
        <ModalFooter>
          <Button variant='raised' primary={true} onClick={(e) => {this.state.isEditing ? this._onEditLocation(this.state.id) : this._onCreateNewLocation()} }>
            {this.state.isEditing ? 'Edit' : 'Create'}
          </Button>
          <Button variant='raised' style={{ marginLeft: 20 }} onClick={(e) => {this.setState({ isEditing: false, modal: null })}}>
            Cancel
          </Button>
        </ModalFooter>
      </ReactModal>
    );
  }

  // render the Create Offer modal
  renderOfferModal() {

    const { offerEditingLocationId } = this.state;

    const archive = (this.props.locations.find(
      v => v.id === offerEditingLocationId) || {}).offersArchive;

    const archiveLoader = archive ? (
      <Grid container>
        <ItemGrid xs={12} sm={12} md={12}>
          <FormControl
            fullWidth
            style={{backgroundColor: '#eee', marginTop: '2rem'}}
          >
            <InputLabel
              htmlFor="archive"
            >
              Load offer from archive...
            </InputLabel>
            <Select
              value={this.state.archiveValue}
              onChange={({ target: {value}}) => {
                this.setState({
                  archiveValue: value,
                  ...(archive[value] || {})
                })
              }}
              fullWidth
              inputProps={{
                name: 'archive',
                id: 'archive',
              }}
            >
              <MenuItem value="">
                <em>Cancel</em>
              </MenuItem>
              {
                Object.keys(archive).map(id =>
                  <MenuItem
                    key={id}
                    value={id}
                  >
                    {archive[id].offerName || archive[id].offerTitle}
                  </MenuItem>
                )
              }
            </Select>
          </FormControl>
        </ItemGrid>
      </Grid>
    ) : null;

    return (
      <ReactModal
        isOpen={this.state.modal === 'offer'}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.offerId ? 'Edit Offer' : 'New Offer'}
        ariaHideApp={false}
        style={customModalStyles}
      >
        <ModalHeader>
          {this.state.offerId ? 'Edit Offer' : 'New Offer'}
        </ModalHeader>
        <ModalContent>
          <Grid container>
            <ItemGrid xs={12} sm={12} md={12}>
              <CustomInput
                labelText='Offer Name'
                id='offerName'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.offerName,
                  onChange: (e)=>this.setState({ offerName: e.target.value })
                }}
              />
            </ItemGrid>
            <ItemGrid xs={12} sm={12} md={12}>
              <CustomInput
                labelText='Offer Title'
                id='offerTitle'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.offerTitle,
                  onChange: (e)=>this.setState({ offerTitle: e.target.value })
                }}
              />
            </ItemGrid>
            <ItemGrid xs={12} sm={12} md={12}>
              <CustomInput
                labelText='Offer Sub Title'
                id='offerSubTitle'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.offerSubTitle,
                  onChange: (e)=>this.setState({ offerSubTitle: e.target.value })
                }}
              />
            </ItemGrid>
          </Grid>
          {archiveLoader}
        </ModalContent>
        <ModalFooter>
          {this.state.offerId && (
            <Button
              variant='raised'
              primary={true}
              onClick={() => this.saveOffer() }
            >
              Save Changes
            </Button>
            )
          }
          {this.state.offerId && (
            <Button
              style={{ marginLeft: 20 }}
              variant='raised'
              primary={true}
              onClick={() => this.archiveOffer() }
            >
              Archive
            </Button>
            )
          }
          {!this.state.offerId && (
            <Button
              variant='raised'
              primary={true}
              onClick={() => this.saveOffer() }
            >
              Create New
            </Button>
            )}
          {!this.state.offerId && (
            <Button
              variant='raised'
              style={{ marginLeft: 20 }}
              primary={true}
              onClick={(e) => this.turnOffOffer() }
            >
              Turn off
            </Button>
            )}
          <Button variant='raised' style={{ marginLeft: 20 }} onClick={(e) => {this.setState({ isEditing: false, modal: null })}}>
            Cancel
          </Button>
        </ModalFooter>
      </ReactModal>
    );
  }

  render() {
    const { classes, locations, isLoading } = this.props;
    return (
      <RegularCard
        cardTitle="Locations"
        cardSubtitle="All Storefronts, Hours, Other Info"
        content={
          <Table className={classes.table}>
            {/* Table Head describing table contents */}
            <TableHead>
              <TableRow>
                {/* Location Name */}
                <CustomTableCell>
                  Name
                </CustomTableCell>
                {/* Location Email */}
                <CustomTableCell>
                  Email
                </CustomTableCell>
                {/* Location Phone # */}
                <CustomTableCell>
                  Phone
                </CustomTableCell>
                {/* Location...well, Location */}
                <CustomTableCell>
                  Location
                </CustomTableCell>
                {/* whether a Location has any Offers */}
                <CustomTableCell>
                  Offer
                </CustomTableCell>
                {/* Edit/Delete actions */}
                <CustomTableCell>
                  Actions
                </CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {isLoading && <div style={{padding: 10, textAlign: 'center'}}>
              <CircularProgress /> </div>
            }
            {!isLoading && !isEmpty(locations) && locations.map(n => {
              const { offerId } = n;
              return (
              <TableRow className={classes.row} key={n.id}>
                <CustomTableCell>
                  {n.name}
                </CustomTableCell>
                <CustomTableCell>
                  {n.email}
                </CustomTableCell>
                <CustomTableCell>
                  {n.phone}
                </CustomTableCell>
                <CustomTableCell>
                  {n.location}
                </CustomTableCell>
                <CustomTableCell>
                  <Button
                    style={{background: offerId ? '#a4c888' : '#8fbbe3'}}
                    onClick={() => this.setState({
                      modal: 'offer',
                      offerEditingLocationId: n.id,
                      offerId: n.offerId,
                      offerName: n.offerName || '',
                      offerTitle: n.offerTitle || '',
                      offerSubTitle: n.offerSubTitle || '',
                      archiveValue: null,
                    })}
                  >
                    { offerId ? 'ACTIVE' : 'CREATE'}
                  </Button>
                </CustomTableCell>
                {/* Edit and Delete buttons */}
                <CustomTableCell>
                  <IconButton
                    tooltip="Edit Location"
                    iconStyle={{ fill: 'rgb(15, 102, 128)' }}
                    onClick={(e) => this.initEditLocation(n.id)}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton tooltip="Delete Location" iconStyle={{ fill: 'rgb(15, 102, 128)' }} onClick={(e) => {this._onDeleteLocation(n.id)}}><DeleteIcon /></IconButton>
                </CustomTableCell>
              </TableRow>
              );
            })}
              {/* Add New Location button */}
              <TableRow>
                <TableCell colSpan={6}>
                  <Button
                    style={{background: '#E5e5e5'}}
                    onClick={() => this.showEditModal()}
                  >
                    Add New Location
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
            {/* Modals */}
            {
              this.state.modal === 'edit' ? this.renderEditModal() :
              this.state.modal === 'offer' ? this.renderOfferModal() :
              null
            }
          </Table>
        }
      />
    );
  }
}

LocationsList.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  locations: state.locationReducer.locations,
  isLoading: state.locationReducer.isLoading
});

const mapDispatchToProps = {
  loadLocations,
  createNewLocation,
  editLocation,
  archiveLocationOffer,
  deleteLocation
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LocationsList));
